module.exports = __webpack_public_path__ + "static/media/generativeintro.f403f62f.glb";